import DefiOpportunitiesCard from "@components/defi-v2/DefiOpportunitiesCard";
import { getImgSrcFromStorage } from "@components/StorageImage";
import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
  Typography,
} from "@kelp-dao/kernel-design-system";
import { DeFiRow } from "./type";
import { trackEvent } from "@lib/utils";
import { TOP_OPPORTUNITIES_SCROLLED } from "@constants/analytics";

const FeaturedDefi = ({ featuredData }: { featuredData: DeFiRow[] }) => {
  if (featuredData.length === 0) {
    return null;
  }

  const handleCarouselScroll = () => {
    trackEvent(TOP_OPPORTUNITIES_SCROLLED, {});
  };
  return (
    <>
      <div className="flex items-center gap-0.5">
        <Typography
          type="heading"
          variant="xxsmall"
          className="text-text-primary font-sans"
        >
          Top Opportunities
        </Typography>
      </div>
      <Carousel
        opts={{
          align: "start",
          loop: false,
        }}
        className="w-full"
      >
        <CarouselContent className="-ml-2 md:-ml-4">
          {featuredData.map((item: DeFiRow, idx: number) => (
            <CarouselItem
              key={`featured_${idx}`}
              className="pl-2 md:pl-4 lg:basis-1/3"
            >
              <div className="flex w-full h-full">
                <DefiOpportunitiesCard
                  tokenName={item.Pair || ""}
                  mainImg={
                    item["Token 1 Icon"]
                      ? getImgSrcFromStorage(item["Token 1 Icon"])
                      : undefined
                  }
                  overlayTokenImg={
                    item["Token 2 Icon"]
                      ? getImgSrcFromStorage(item["Token 2 Icon"])
                      : undefined
                  }
                  icon={
                    item.Provider
                      ? getImgSrcFromStorage(item.Provider)
                      : undefined
                  }
                  chip1Text={item.Activity || undefined}
                  chip2Text={
                    item.Tags ? item.Tags.split(",")[0]?.trim() : undefined
                  }
                  tvl={item.TVL || undefined}
                  apy={item.APY || undefined}
                  row={item}
                  featuredDefi={true}
                />
              </div>
            </CarouselItem>
          ))}
        </CarouselContent>
        <CarouselPrevious
          className="hidden lg:flex"
          onClick={handleCarouselScroll}
        />
        <CarouselNext
          className="hidden lg:flex"
          onClick={handleCarouselScroll}
        />
      </Carousel>
    </>
  );
};

export default FeaturedDefi;
